export interface InteractionCreateInterface {
  conversationId?: number;
  subject: string;
  communicationType: string;
  description: string;
}
